import type { Academy } from '@court-sync/shared';
import { PublicContactFooter } from './PublicContactFooter';

export function PublicAcademyContactFooter({
  academy,
  showMultiLocationPublic = false,
  className,
}: {
  academy: Pick<Academy, 'name' | 'address' | 'phone' | 'email' | 'website'>;
  showMultiLocationPublic?: boolean;
  className?: string;
}) {
  return (
    <PublicContactFooter
      entity={academy}
      showMultiLocationPublic={showMultiLocationPublic}
      className={className}
    />
  );
}
